<template>
  <layout title="Dispute Letters">
    <dynamic-table-view
        ref="table"
        :headers="headers"
        :list="list"
        :loading="loading"
    >
      <template v-slot:item.status="{ item }">
        <span
          class="font-weight-bold"
          :class="getAffiliateStatus(item) === 'Sent' ? 'green--text' : 'grey--text'"
        >{{ getAffiliateStatus(item) }}</span>
      </template>
      <template v-slot:item.customer_name="{ value, item }">
        <router-link
          class="text-decoration-none"
          :to="{ name: 'client-profile', params: { id: item.customer } }"
        >
          {{ value }}
        </router-link>
      </template>
    </dynamic-table-view>
  </layout>
</template>
<script>
import Layout from "@/components/ui/Layout.vue";
import DynamicTableView from "@/components/ui/DynamicTableView.vue";
import {auth, colClients, colFaxes} from "@/assets/utils/firebase.utils";
import {getDocs, query, where, orderBy} from "firebase/firestore";
import {mapDocs} from "@/assets/utils/doc.utils";
import {chunk} from "lodash";

export default {
  components: {
    Layout,
    DynamicTableView,
  },
  data() {
    return {
      headers: [
        {text: "Status", value: "status", sortable: false},
        {text: "Client", value: "customer_name", sortable: false},
        {text: "Title", value: "fax_title", sortable: false},
        {text: "Send Date", value: "created_at", sortable: false},
        {text: "Updated Date", value: "updated_at", sortable: false},
      ],
      list: [],
      loading: false,
    };
  },
  methods: {
    getAffiliateStatus(item) {
      const status = item.status || "";
      if (!status || status === "DRAFT" || status === "SENDING" ||
          status === "SUCCESS" || status === "COMPLETED" ||
          status === "FAILED" || status.startsWith("SENT TO")) {
        return "Draft";
      }
      return "Sent";
    },
    async fetchData() {
      try {
        this.loading = true;
        const uid = auth.currentUser.uid;

        // Query clients by all 3 affiliate_id fields in parallel
        const [res1, res2, res3] = await Promise.all([
          getDocs(query(colClients, where("affiliate_id", "==", uid))),
          getDocs(query(colClients, where("affiliate_id_2", "==", uid))),
          getDocs(query(colClients, where("affiliate_id_3", "==", uid))),
        ]);

        // Merge unique client IDs
        const clientIdSet = new Set();
        [res1, res2, res3].forEach((snap) => {
          snap.docs.forEach((doc) => clientIdSet.add(doc.id));
        });
        const clientIds = Array.from(clientIdSet);

        if (clientIds.length === 0) {
          this.list = [];
          this.loading = false;
          return;
        }

        // Query faxes in batches of 30 (Firestore "in" limit)
        const batches = chunk(clientIds, 30);
        const faxResults = await Promise.all(
          batches.map((batch) =>
            getDocs(
              query(
                colFaxes,
                where("customer", "in", batch),
                orderBy("created_at", "desc")
              )
            )
          )
        );

        // Merge and sort results by created_at descending
        const allDocs = faxResults.flatMap((snap) => snap.docs);
        if (batches.length > 1) {
          allDocs.sort((a, b) => {
            const aTime = a.data().created_at;
            const bTime = b.data().created_at;
            if (!aTime) return 1;
            if (!bTime) return -1;
            return bTime.seconds - aTime.seconds;
          });
        }

        this.list = mapDocs(allDocs);
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
